const TAMIL_PYTHON_COURSE = require("./tamil/python_course")

module.exports = [TAMIL_PYTHON_COURSE]
